import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/Logo_Ambitus.png';

const footerLinks = [
  { id: 'about', href: '#About' },
  { id: 'projects', href: '#Projects' },
  { id: 'applications', href: '#Applications' },
  { id: 'advantages', href: '#Advantages' },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="ambitus-footer">
      <div className="ambitus-footer__container">
        <div className="ambitus-footer__brand">
          <a className="ambitus-footer__logo" href="/" aria-label="Ambitus Strategy">
            <img src={logo} width="50" height="60" alt="" />
            <span>Ambitus Strategy</span>
          </a>
          <p>{t('footer.tagline')}</p>
        </div>

        <nav className="ambitus-footer__column" aria-label={t('footer.navigationLabel')}>
          <h2>{t('footer.usefulLinks')}</h2>
          <ul>
            {footerLinks.map((link) => (
              <li key={link.id}>
                <a href={link.href}>{t(`nav.${link.id}`)}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="ambitus-footer__column ambitus-footer__contacts">
          <h2>{t('footer.contacts')}</h2>
          <a href="mailto:a.capelas@ambitustrategy.com">a.capelas@ambitustrategy.com</a>
          <a href="tel:+351925460087">+351 925 460 087</a>
          <a
            href="https://apambiente.pt/agua/agua-para-reutilizacao-apr"
            target="_blank"
            rel="noreferrer"
          >
            {t('footer.legislation')}
          </a>
          <button
            className="ambitus-footer__cookie-button"
            type="button"
            onClick={() => window.dispatchEvent(new Event('ambitus:open-cookie-settings'))}
          >
            {t('footer.cookieSettings')}
          </button>
        </div>
      </div>

      <div className="ambitus-footer__bottom">
        <p>© {year} {t('footer.copyright')}</p>
      </div>
    </footer>
  );
}
